import { __assign } from "tslib";
import { overrides } from './overrides';
import { props } from './props';
/**
 * We split out a 'base theme' with just colors
 * and typography so that the props & overrides
 * sections can utilize theme tooling like spacing and
 * palette without creating circular dependencies
 */
import baseTheme from './baseTheme';
export default __assign(__assign({}, baseTheme), { overrides: overrides,
    props: props });
//# sourceMappingURL=theme.js.map